module.exports = __webpack_public_path__ + "static/media/generar-reporte-light.6d62544c.png";